<template>
  <v-card class="lighten-5" flat>
    <v-card-title class="grey lighten-3">
      <h4 class="topic">Contato de revenda</h4>
    </v-card-title>
    <v-card-text>
      <v-form ref="formContato" v-model="formContatoValid" lazy-validation>
        <v-layout wrap>
          <v-flex d-flex xs12 sm10>
            <v-layout row wrap>
              <v-flex d-flex xs12 sm6 class="form-group">
                <v-text-field label="Nome" :rules="lengthRule100" v-model="projeto.contatoRevenda.nome"></v-text-field>
              </v-flex>
              <v-flex d-flex xs12 sm6 class="form-group">
                <v-text-field label="Empresa" :rules="lengthRule60"
                  v-model="projeto.contatoRevenda.empresa"></v-text-field>
              </v-flex>
              <v-flex d-flex xs12 sm3 class="form-group">
                <v-text-field label="Site" :rules="lengthRule50" v-model="projeto.contatoRevenda.site"></v-text-field>
              </v-flex>
              <v-flex d-flex xs12 sm3 class="form-group">
                <v-text-field label="E-mail" :rules="lengthRule50" v-model="projeto.contatoRevenda.email"></v-text-field>
              </v-flex>
              <v-flex d-flex xs12 sm3 class="form-group">
                <v-text-field label="Telefone" v-mask="phoneMask"
                  v-model="projeto.contatoRevenda.telefone"></v-text-field>
              </v-flex>
              <v-flex d-flex xs12 sm3 class="form-group">
                <v-text-field label="CEP" v-model="projeto.contatoRevenda.cep" v-mask="cepMask"></v-text-field>
              </v-flex>
              <v-flex d-flex xs12 sm6 class="form-group">
                <v-text-field label="Endereço" :rules="lengthRule60"
                  v-model="projeto.contatoRevenda.endereco"></v-text-field>
              </v-flex>
              <v-flex d-flex xs8 sm3 class="form-group">
                <v-text-field label="Cidade" :rules="lengthRule25" v-model="projeto.contatoRevenda.cidade"></v-text-field>
              </v-flex>
              <v-flex d-flex xs4 sm3 class="form-group">
                <v-text-field label="Estado" v-model="projeto.contatoRevenda.estado"></v-text-field>
              </v-flex>
              <v-flex d-flex xs8 sm12 class="form-group">
                <v-text-field label="Sobre" v-model="projeto.contatoRevenda.sobre"></v-text-field>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex d-flex xs12 sm2>
            <div>
              <v-flex d-flex xs12 sm12>
                <v-img :src="projeto.imagemUrl" v-if="projeto.imagemUrl" class="logo"></v-img>
                <v-img :src="logoImage" v-else-if="logoImage" class="logo"></v-img>
              </v-flex>
              <v-flex d-flex xs12 sm12>
                <UploadBtn title="ANEXAR LOGO" @file-update="fileUpdate" no-title-update></UploadBtn>
              </v-flex>
            </div>
          </v-flex>
        </v-layout>
      </v-form>
    </v-card-text>
  </v-card>
</template>

<script>
import UploadBtn from "./UploadButton";
import { mapActions, mapGetters } from "vuex";

export default {
  name: "ProjectContractRetail",
  components: { UploadBtn },
  computed: mapGetters(['projeto']),
  data() {
    return {
      formContatoValid: true,
      lengthRule25: [
        v => (!v || (v.length >= 0 && v.length <= 25)) || 'Campo pode ter no máximo 25 caracteres'
      ],
      lengthRule50: [
        v => (!v || (v.length >= 0 && v.length <= 50)) || 'Campo pode ter no máximo 50 caracteres'
      ],
      lengthRule60: [
        v => (!v || (v.length >= 0 && v.length <= 60)) || 'Campo pode ter no máximo 60 caracteres'
      ],
      lengthRule100: [
        v => (!v || (v.length >= 0 && v.length <= 100)) || 'Campo pode ter no máximo 100 caracteres'
      ],
      logoImage: require('./icons/empty.svg'),
      logoFile: null,
      phoneMask: '(##) #####-####', //utilizar ['(##) ####-####','(##) #####-####'] causa loop infinito por causa do Vuex
      cepMask: '#####-###'
    }
  },
  created() {
    this.loadContatoRevenda();
  },
  methods: {
    ...mapActions(['loadContatoRevenda']),
    fileUpdate(file) {
      const fr = new FileReader();
      if (file) {
        fr.readAsDataURL(file);
        fr.addEventListener('load', () => {
          this.logoImage = fr.result;
          this.logoFile = file // this is an image file that can be sent to server...
          this.projeto.contatoRevenda.imagem = this.logoFile.name;
          this.projeto.contatoRevenda.imagemBase64 = this.logoImage;
        });
      } else {
        this.logoImage = require('./icons/empty.svg');
        this.projeto.contatoRevenda.imagem = '';
        this.projeto.contatoRevenda.imagemBase64 = '';
      }
    },
    validate() {
      this.$refs.formContato.validate();
      this.$emit("validated", this.formContatoValid);
    },
    reset() {
      this.$refs.formContato.reset();
      this.$emit("reseted", this.formContatoValid);
    },
    resetValidation() {
      this.$refs.formContato.resetValidation();
      this.$emit("validationreseted", this.formContatoValid);
    },
  }
}
</script>

<style scoped></style>
